import { responsiveVanillaSelector } from '../selectors';
import type { Site } from '../Site';

export const NextTV: Site = {
  id: 'nexttv',
  logo: 'svg/nexttv.svg',
  label: 'NextTV',
  analyticsName: 'nexttv',
  hostname: 'nexttv.com',
  platform: 'responsive',
  selector: responsiveVanillaSelector,
};
